import _ from 'lodash'
import React, {useCallback, useMemo, useState} from 'react'
import {Box, List} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import './announcement-bar.scss'
import AnnouncementBarSlide from './announcement-bar-slide'
import {useCookies} from 'react-cookie'

const in2Days = new Date(new Date().getTime() + 2 * 24 * 60 * 60 * 1000)

const AnnouncementBar = ({data}) => {
    const [cookies, setCookie] = useCookies(['rennai_hidden_announcements'])
    const {rennai_hidden_announcements = ''} = cookies
    const speed = useMemo(() => data?.speed || 500, [data])

    const announcementData = useMemo(() => {
        const slides = data?.slides ?? []
        const items = rennai_hidden_announcements.split(',')
        const aSlides = slides.filter((item) => !items.includes(item?.sys?.id))

        return {
            items: aSlides?.length === 1 ? [...aSlides, ...aSlides] : aSlides,
            hasMoreItems: aSlides?.length > 1
        }
    }, [rennai_hidden_announcements, data])

    const onHideAnnouncementBar = useCallback(
        (key) => {
            setCookie(
                'rennai_hidden_announcements',
                rennai_hidden_announcements?.length > 0
                    ? `${rennai_hidden_announcements},${key}`
                    : key,
                {expires: in2Days}
            )
        },
        [in2Days, rennai_hidden_announcements]
    )

    const settings = useMemo(
        () => ({
            dots: false,
            infinite: true,
            speed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: announcementData?.hasMoreItems,
            autoplaySpeed: speed > 0 ? speed : 500,
            arrows: false
        }),
        [announcementData]
    )

    if (!announcementData?.items?.length) return <></>

    return (
        <Box position="relative" width="100vw" height="auto">
            <List>
                <Slider
                    {...settings}
                    className="announcement-bar"
                    height="100%"
                >
                    {_.map(
                        announcementData?.items ?? [],
                        ({sys, fields: announcement}, index) => {
                            const text = {
                                ...announcement?.text,
                                content: announcement?.text?.content?.map(
                                    (itm) => ({
                                        ...itm,
                                        content: itm?.content?.filter(
                                            (itmCT) => itmCT?.value !== ''
                                        )
                                    })
                                )
                            }

                            return (
                                <AnnouncementBarSlide
                                    sys={sys}
                                    key={`${announcement?.contentfulTitle}-${index}`}
                                    text={text}
                                    theme={announcement?.theme}
                                    onClose={onHideAnnouncementBar}
                                />
                            )
                        }
                    )}
                </Slider>
            </List>
        </Box>
    )
}

AnnouncementBar.propTypes = {
    data: PropTypes.shape({
        speed: PropTypes.number,
        slides: PropTypes.arrayOf(PropTypes.object)
    })
}

AnnouncementBar.displayName = 'AnnouncementBar'

export default AnnouncementBar
